import type { ResourceType } from "@gettactic/api";

/**
 * Resource types reserved together with `resourceType`: desks and
 * workspaces share one flow, as do parking lots and spaces.
 */
export const getResourceTypeGroup = (
  resourceType: ResourceType
): ResourceType[] => {
  if (resourceType === "desk" || resourceType === "workspace") {
    return ["desk", "workspace"];
  }
  if (resourceType === "parking_space" || resourceType === "parking_lot") {
    return ["parking_lot", "parking_space"];
  }
  return ["meeting_room"];
};
